// which components should be available in the Vue.js (and thus also in the .html.erb)
export default function() {
  return require.context('./vue/components/' , true, /\.vue$/)
}
